<article class="lum-c-automation-rule  lum-page lum-page__card">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">Automation</h2>
    <div class="lum-page-header__actions">
      <button
        type="button"
        class="lum-button lum-button--primary"
        (click)="onCreateRule()"
      >
        <lum-ui-icon class="mr-2" icon="add-1"></lum-ui-icon>
        Create Rule
      </button>
    </div>
  </header>

  <mat-tab-group animationDuration="0">
    <mat-tab label="Rules">
      <div class="lum-c-automation-rule__content lum-page-content">
        <lum-automation-rule-table
          [rules]="rules"
          [loading]="loading"
          (deleteRuleEvent)="onDeleteRule($event)"
          (updateRuleEvent)="onUpdateRule($event)"
        ></lum-automation-rule-table>
        <mat-paginator
          [length]="pagination.total || 0"
          [pageSize]="pagination.per_page || paginationConfig.perPage"
          [pageSizeOptions]="paginationConfig.pageSizeOptions"
          [pageIndex]="(pagination.current_page || 1) - 1"
          (page)="onPaginationEvent($event)"
          aria-label="Select page"
        ></mat-paginator>
      </div>
    </mat-tab>

    <mat-tab label="Testing">
      <div class="lum-c-automation-rule__testing-tab lum-page-content">
        <form
          [formGroup]="testingForm"
          (ngSubmit)="triggerTest()"
          class="testing-form"
        >
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>Model Type</mat-label>
              <mat-select formControlName="model_type" required>
                <mat-option *ngFor="let type of modelTypes" [value]="type">{{
                  type | titlecase
                }}</mat-option>
                <!-- TODO: Fetch actual model types -->
              </mat-select>
              <mat-error
                *ngIf="testingForm.get('model_type')?.hasError('required')"
              >
                Model Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Model ID</mat-label>
              <input matInput formControlName="model_id" required />
              <mat-error *ngIf="testingForm.get('model_id')?.hasError('required')">
                Model ID is required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Event Name</mat-label>
              <mat-select formControlName="event_name" required>
                <mat-option *ngFor="let event of eventNames" [value]="event">{{
                  event | titlecase
                }}</mat-option>
                <!-- TODO: Fetch actual event names -->
              </mat-select>
              <mat-error
                *ngIf="testingForm.get('event_name')?.hasError('required')"
              >
                Event Name is required
              </mat-error>
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="testingForm.invalid && !isPolling"
              (click)="isPolling ? stopPolling() : triggerTest()"
            >
              <ng-container *ngIf="!isPolling">Trigger Test</ng-container>
              <ng-container *ngIf="isPolling">Stop</ng-container>
            </button>
          </div>
        </form>

        <div class="activity-log">
          <div class="activity-log__header">
            <h3>Activity Log</h3>
            <div class="activity-log__actions">
              <button
                mat-button
                (click)="clearLogs()"
                [disabled]="logs.length === 0 || isPolling"
                class="clear-button"
              >
                <mat-icon>clear_all</mat-icon>
                Clear
              </button>
              <button
                mat-button
                (click)="downloadLog()"
                [disabled]="logs.length === 0 || isPolling"
                class="download-button"
              >
                <mat-icon>download</mat-icon>
                Download Log
              </button>
            </div>
          </div>

          <div class="log-level-filters">
            <button
              *ngFor="let level of logLevels"
              type="button"
              class="log-level-filter"
              [class.active]="level === selectedLogLevel"
              [disabled]="isPolling"
              (click)="onLogLevelSelectionChange(level)"
            >
              {{ level }}
            </button>
          </div>

          <div class="log-container" #logContainer>
            <ng-container *ngIf="logs.length > 0; else noLogs">
              <div
                *ngFor="let entry of filteredLogs; trackBy: trackLogById"
                class="log-entry"
                [ngClass]="'log-level-' + entry.level.toLowerCase()"
              >
                <span class="log-timestamp"
                  >[{{ entry.timestamp | date: 'short' }}]</span
                >
                <span class="log-level">[{{ entry.level }}]</span>
                <span class="log-description">{{ entry.description }}</span>

                <ng-container
                  *ngIf="entry.context && objectNotEmpty(entry.context)"
                >
                  <div class="log-context">
                    <button
                      mat-button
                      (click)="toggleJson(entry.id)"
                      class="json-toggle-button"
                    >
                      <mat-icon>{{
                        showJson[entry.id] ? 'visibility_off' : 'visibility'
                      }}</mat-icon>
                      {{ showJson[entry.id] ? 'Hide' : 'Show' }} JSON
                    </button>
                    <button
                      mat-icon-button
                      (click)="copyJson(entry.context)"
                      aria-label="Copy JSON"
                    >
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                  <pre
                    *ngIf="showJson[entry.id]"
                    class="json-viewer"
                  ><code>{{ entry.context | json }}</code></pre>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noLogs>
              <div class="no-logs-message">
                <p *ngIf="!currentRunId">Trigger a test event to see logs.</p>
                <p *ngIf="currentRunId && !isPolling && logs.length === 0"
                  >No logs generated for this run.</p
                >
                <p *ngIf="currentRunId && isPolling && logs.length === 0"
                  >Waiting for logs...</p
                >
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</article>
